import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { Card, CardBody, CardHeader, Col, Button, Container, Input, Row } from 'reactstrap';
import BreadCrumb from '../../Components/Common/BreadCrumb';
// import PDFTab from './Documents';
import Documents from './Documents';

const DocumentList = () => {


    return (
        <React.Fragment>
            <div className='page-content'>
                <Container fluid>
                    <Col>
                        <BreadCrumb title="Documents" />
                        <Card>
                            <CardBody>
                                <Row>
                                    <Documents />
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default DocumentList;
